import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Badge } from "../ui/badge";
import { toast } from "sonner";
import { Store } from "lucide-react";

export function MerchantInfoPanel() {
  const [merchant, setMerchant] = useState(null);
  const [form, setForm] = useState({ telephone: "", email_contact: "", adresse: "" });
  const [submitting, setSubmitting] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/me/merchant");
      setMerchant(data);
      setForm({
        telephone: data.telephone || "",
        email_contact: data.email_contact || "",
        adresse: data.adresse || "",
      });
    } catch (err) { toast.error(formatApiError(err)); }
  };
  useEffect(() => { load(); }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.patch("/me/merchant", {
        telephone: form.telephone.trim() || undefined,
        email_contact: form.email_contact.trim() || undefined,
        adresse: form.adresse.trim() || undefined,
      });
      toast.success("Informations mises à jour");
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setSubmitting(false); }
  };

  if (!merchant) return <div className="text-sm text-[#687175] py-10 text-center">Chargement…</div>;

  return (
    <div className="bg-white rounded-2xl border border-[#E5E7EB] shadow-[0_8px_24px_rgba(57,125,255,0.06)] p-6 sm:p-7 max-w-2xl" data-testid="merchant-info-panel">
      <div className="flex items-center gap-2 mb-1">
        <Store className="w-5 h-5 text-[#397DFF]" />
        <h2 className="font-display text-2xl font-bold text-[#191D1E]">Mon commerce</h2>
      </div>
      <p className="text-sm text-[#687175] mb-6">
        Ces informations apparaissent dans vos communications clients. Le nom, l'activité et la zone sont gérés par votre administrateur.
      </p>

      <div className="bg-[#F5F6F9] border border-[#E5E7EB] rounded-xl px-4 py-3 mb-5" data-testid="merchant-info-readonly">
        <div className="font-semibold text-[#191D1E]">{merchant.nom}</div>
        <div className="text-sm text-[#687175] mt-0.5">{merchant.trade_label} · {merchant.ville} {merchant.code_postal}</div>
        <Badge className="bg-[#EEF4FB] text-[#397DFF] border border-[#D7E5F4] mt-2">Zone : {merchant.zone || "—"}</Badge>
      </div>

      <form onSubmit={onSubmit} className="space-y-4" data-testid="merchant-info-form">
        <div className="space-y-1.5">
          <Label>Téléphone</Label>
          <Input data-testid="mi-telephone" value={form.telephone} onChange={(e) => setForm((f) => ({ ...f, telephone: e.target.value }))} />
        </div>
        <div className="space-y-1.5">
          <Label>Email contact</Label>
          <Input type="email" data-testid="mi-email" value={form.email_contact} onChange={(e) => setForm((f) => ({ ...f, email_contact: e.target.value }))} />
        </div>
        <div className="space-y-1.5">
          <Label>Adresse</Label>
          <Input data-testid="mi-adresse" value={form.adresse} onChange={(e) => setForm((f) => ({ ...f, adresse: e.target.value }))} />
        </div>
        <Button type="submit" disabled={submitting} data-testid="mi-submit" className="bg-[#F9C80E] hover:bg-[#DDB10A] text-[#191D1E] font-semibold rounded-xl">
          {submitting ? "Enregistrement…" : "Enregistrer"}
        </Button>
      </form>
    </div>
  );
}

export default MerchantInfoPanel;
